import jsyaml from 'js-yaml';
import { PluginBase } from '../plugin.js';
import { NullYamlTransformer, YamlTransformer } from './YamlTransformer.js';
import { AsyncJsDatasetService } from './AsyncJsDatasetService.js';
import { DatasetService } from '../dataset.js';


export class AsyncYamlDatasetService extends AsyncJsDatasetService implements DatasetService {
  private constructor() {
    super();
  }

  static async create(schemaFile: string,
                      dataFiles: string[]              = [],
                      plugins: (string | PluginBase)[] = [],
                      transformer: YamlTransformer     = new NullYamlTransformer()): Promise<AsyncYamlDatasetService> {
    const datasetService = new AsyncYamlDatasetService();
    let loadedSchema = jsyaml.safeLoad(schemaFile);
    const data = dataFiles.map(dataFile => jsyaml.safeLoadAll(dataFile));

    await datasetService.init(loadedSchema, data, plugins, transformer);
    return datasetService;
  }
  
  addDatasets(datasets: any[]) {
    const data = datasets.map(dataFile => jsyaml.safeLoadAll(dataFile).filter(data => !!data));
    super.addDatasets(data);
  }
}

